/****************************************************
 * Module Name:  settingsProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class SettingsProxy {
  static GetAllSettings = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/setting",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleSettings = (SettingId, callback) => {
    let params = {
      id: SettingId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/setting",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSettingByName = (settingKeys, callback) => {
    let params = {
      setting: settingKeys,
    };

    restAPICall(
      Constants.MANAGER_URL + "/setting",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSettingsByName = (settingKeys, callback) => {
    let params = {
      setting: settingKeys.join(","),
    };

    restAPICall(
      Constants.MANAGER_URL + "/setting/multiple",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckSettingsAvailable = (setting, callback) => {
    let params = {
      setting: setting,
    };

    restAPICall(
      Constants.MANAGER_URL + "/setting/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddSettings = (setting, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/setting",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(setting),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateSettings = (setting, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/setting",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(setting),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
